"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page = void 0;
var rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
Object.defineProperty(exports, "Page", { enumerable: true, get: function () { return rpdf_renderer_1.Page; } });
//# sourceMappingURL=page.js.map